import React from 'react'
import Container from 'components/Container'
import { Button } from '@pancakeswap-libs/uikit'
import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { useProjectList } from 'data/ProjectList'
import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { useActiveWeb3React } from '../../hooks'
import AppBody from '../AppBody'
import { Wrapper, Name, Desc, CopyIcon, NoMore } from './styleds'
import copyImg from '../../assets/images/copy.png'

export default function ProjectList() {
   const { account } = useActiveWeb3React()
   const { toastSuccess } = useToast()
   const tokenList:any = useProjectList(account ?? undefined)
   
   const { t } = useTranslation()
   
   const handleCopy = (address) => {
      copy(address)
      toastSuccess(t('copy successfully'))
    }

  return (
  <Container>
  { tokenList.length > 0 ? (tokenList.map((item:any) => (
  <AppBody key={ item.tokenAddress }>
    <Wrapper>
       <RowBetween marginBottom='20px'>
         <div>
            <Name>{ item.symbol }</Name>
            <Desc>{ t('Symbol') }</Desc>
         </div>
         <div>
            <Name>{ item.amount }</Name>
            <Desc>{ t('Token amount') }</Desc>
         </div>
         <div>
            <Name className='active'>{ t('Success') }</Name>
            <Desc>{ t('Status') }</Desc>
         </div>
       </RowBetween>
       <Name style={{ textAlign: 'left' }}>{ t('Contract address') }</Name>
       <RowBetween>
         <Desc className='address'>{ item.tokenAddress }</Desc>
         <CopyIcon src={ copyImg } size='15px' onClick={(event) => {
                      event.stopPropagation()
                       handleCopy(item.tokenAddress)
                    }}/>
       </RowBetween>
       <RowBetween style={{ marginTop: '1rem' }}>
         <HistoryLink to={ `/register/${item.lockAdderss}` }>
             <Button width="100%">{ t('Add option token') }</Button>
         </HistoryLink>
        <HistoryLink to={ `/airdrop/${item.lockAdderss}` }>
             <Button width="100%">{ t('Transaction release contract') }</Button>
         </HistoryLink>
       </RowBetween>
    </Wrapper>
  </AppBody>))) : <NoMore>{ t('No records') }</NoMore>}
 </Container>
)}